import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "accept", "multiple"]

import { ref } from 'vue';

interface AppInputProps {
	id: string;
	resetOnSelect?: boolean;
	multiple?: boolean;
	accept?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFileInput',
  props: {
    id: {},
    resetOnSelect: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    accept: {}
  },
  emits: [
	'file',
	'files',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const input = ref<HTMLInputElement>();

const reset = () => {
	if (input.value && props.resetOnSelect) {
		input.value.value = '';
	}
};

const changed = () => {
	if (!input.value?.files?.length) {
		return;
	}

	if (props.multiple) {
		emit('files', input.value.files);
		reset();

		return;
	}

	emit('file', input.value.files[0]);
	reset();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "file",
    ref_key: "input",
    ref: input,
    id: _ctx.id,
    accept: _ctx.accept,
    multiple: _ctx.multiple,
    onChange: changed
  }, null, 40, _hoisted_1))
}
}

})